import * as types from './mutation-types';

const mutations = {
	[types.LOGIN_BY_USERNAME](state, payload) {
		state.token = payload.token;
		state.expires = payload.expires;
	},
	[types.LOGIN_TOKEN_OLD](state, payload) {
		state.tokenOld = payload.token;
	},
	[types.GET_MENU_MAP_SORT](state, payload) {
		state.menuSort = payload.menuSort;
	},
	[types.SET_MENU_CATEGORY_INDEX](state, payload) {
		state.menuCategory = payload;
	},
	[types.GET_MENU_MAP](state, payload) {
		state.menu = payload.menu;
	},
	[types.LOGOUT](state) {
		state.token = '';
		state.expires = '';
		state.userInfo = {};
		state.menu = [];
		state.menuSort = [];
		state.tokenOld = '';
	},
	[types.SET_USER_INFO](state, payload) {
		state.userInfo = payload.userInfo;
	},
	[types.SET_APP_INFO](state, payload) {
		state.appInfo = payload.appInfo;
	}
};

export default mutations;
